<template>
  <div class="topbar py-2 px-3 w-100">
    <div class="d-flex justify-space-between align-center">
      <div class="topbar-left">
        <v-btn icon :to="'/share/rooms'">
          <v-icon>far fa-stream</v-icon>
        </v-btn>
      </div>
      <div class="topbar-right text-right">
        <v-tooltip bottom>
          <template #activator="{on}">
            <v-btn icon v-on="on" @click="_startTour">
              <v-icon>far fa-question-circle</v-icon>
            </v-btn>
          </template>
          <span>Hilfe anzeigen</span>
        </v-tooltip>

        <v-tooltip v-if="canInviteUsers" bottom :disabled="isTouchDevice">
          <template #activator="{on}">
            <v-btn icon v-on="on" @click="$emit('roomInviteUser')">
              <v-icon>far fa-user-plus</v-icon>
            </v-btn>
          </template>
          <span>Benutzer einladen</span>
        </v-tooltip>

        <v-tooltip v-if="room && room.id !== 'local'" bottom :disabled="isTouchDevice">
          <template #activator="{on}">
            <v-btn icon :to="'/share/files'" exact v-on="on">
              <v-icon>far fa-folder-upload</v-icon>
            </v-btn>
          </template>
          <span>Dateien</span>
        </v-tooltip>

        <v-tooltip bottom :disabled="isTouchDevice">
          <template #activator="{on}">
            <v-badge
              :content="notifications.length"
              :value="notifications.length"
              color="primary"
              top
              offset-x="15"
              offset-y="15"
            >
              <v-btn icon to="/share/notifications" exact v-on="on">
                <v-icon>far fa-bell-on</v-icon>
              </v-btn>
            </v-badge>
          </template>
          {{$tc('unreadNotifications', notifications.length)}}
        </v-tooltip>

        <UserInfo />
      </div>
    </div>
    <div v-if="room" class="topbar-center d-flex justify-center align-center w-100">
      <router-link class="room-name text-truncate font-weight-500 text--primay-text" :title="room.name" :to="'/share/rooms'">
        {{room.name}}
      </router-link>
    </div>
  </div>
</template>

<script>
  import UserInfo from './UserInfo';
  import {isTouchDevice, canInviteUsers} from '../assets/js/utils';
  import eventBus from '../assets/js/event-bus';


  export default {
    name: 'Topbar',

    components: {
      UserInfo
    },

    data() {
      return {
        isTouchDevice
      };
    },

    computed: {
      room() {
        return this.$store.getters['share/getRoom'];
      },

      canInviteUsers() {
        return !!this.room && canInviteUsers(this.room);
      },

      notifications() {
        return this.$store.getters['share/getNotifications'];
      }
    },

    methods: {
      _startTour() {
        eventBus.$emit('tour-start');
      }
    }
  };
</script>
